"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaVoucherType = void 0;
var MetaVoucherType = /** @class */ (function () {
    function MetaVoucherType() {
    }
    return MetaVoucherType;
}());
exports.MetaVoucherType = MetaVoucherType;
